export default __webpack_public_path__ + "static/media/moralis.3f2b6095.png";